/**
 * A simple extension feed implementation that provides a fixed set of "built in" extensions.
 * "Built in" in this context means extensions that are known at bundling time, and included
 * in the bundle. Each extension can be dynamically imported so they are split into separate
 * bundle chunks and downloaded only when first installed.
 */
export class BuiltInsExtensionFeed {
    constructor(name, extensions) {
        this.name = name;
        this._extensions = Array.from(extensions);
    }
    async queryExtensionsAsync(filter) {
        const filteredExtensions = filter ? this._extensions.filter((extension) => extension.name.includes(filter)) : this._extensions;
        return {
            totalCount: filteredExtensions.length,
            getExtensionMetadataAsync: async (index, count) => {
                return filteredExtensions.slice(index, index + count);
            },
        };
    }
    async getExtensionModuleAsync(name) {
        const extension = this._extensions.find((ext) => ext.name === name);
        return extension ? await extension.getExtensionModuleAsync() : undefined;
    }
}
//# sourceMappingURL=builtInsExtensionFeed.js.map